export default __webpack_public_path__ + "static/media/sobre_mi.47a982cb.jpg";